<script setup lang="ts">
import type * as ProductBtnBuy from './ProductBtnBuy.vue'

const props = defineProps<{
  save: 'before' | 'after' | 'off'
  size?: 's' | 'm' | 'l'
  streach?: boolean
  disabled?: boolean
  stock: number | None
  product: ProductListingFragmentFull | ProductListingBoxFragmentFull
  onQty?: (i: { qty: number; productId: string }) => void
}>()

function isFull(p: ProductListingFragmentFull | ProductListingBoxFragmentFull): boolean {
  if ('imageBox' in p) return false
  return 'media' in p || '' in p
}

const cart = useCart()
const notify = useNotify()
const qty = computed(() => cart.findOneQty(props.product?.id))

const ui = computed((): Omit<ProductBtnBuy.Props, 'qty' | 'qtySet' | 'notify' | 'hideSave'> => {
  const { product, stock, disabled } = props
  const full = isFull(product) ? product : undefined
  const box = !isFull(product) ? product : undefined
  const size = props.size || (box ? 's' : 'l')
  return {
    privateVisibility: product.privateVisibility,
    disabled: disabled || false,
    uiPrice: product._values?._uiPrice,
    settingsQty: product?.settingsQty,
    stock: stock ?? cart.findOneCartItem(props.product?.id)?.stockLeft ?? full?._values?.stock ?? box?._values?.stock,
    size,
    availability: product.availabilityType,
    slug: product.slug,
  }
})

function qtySet(qty: number) {
  const productId = props.product.id
  if (!productId) return
  notify.watch(cart.add({ productId, qty }))
  props.onQty?.({ productId, qty })
}
</script>

<template>
  <ProductBtnBuy v-bind="ui" :qty :qty-set :notify :streach>
    <template v-if="save === 'before'" #before>
      <div><BoardBtnButton :qty right :product-id="product.id" :size="ui.size" /></div>
    </template>
    <slot />
    <div v-if="save === 'after'"><BoardBtnButton :qty :product-id="product.id" :size="ui.size" /></div>
  </ProductBtnBuy>
</template>
